<template>
  <div class="e-dialog e-dialog--new">
    <router-link :to="{ name: 'dialogs' }" class="e-dialog__back">
      <IconChevronLeft />
    </router-link>

    <VuePerfectScrollbar class="e-dialog__inner">
      <div class="e-dialog__scroll">
        <NewMessageEditor :edit-message="editMessage" />
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MessageEditor from 'organisms/MessageEditor/MessageEditor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

// Icons
import IconChevronLeft from 'assets/icons/chevron-left.svg'

const NewMessageEditor = {
  name: 'NewMessageEditor',
  extends: MessageEditor,
  methods: {
    closeForm() {
      this.$router.push({ name: 'dialogs' })
    }
  }
}

export default {
  name: 'NewDialog',
  components: {
    IconChevronLeft,
    NewMessageEditor,
    VuePerfectScrollbar
  },
  computed: {
    ...mapGetters(['editMessage', 'messageEditorOpen'])
  }
}
</script>
